import React from 'react';

import { Resource } from '../../../../common/constants/resource';
import { MVRApplicant } from '../../../tasks/types/mvr';
import { dateToString } from '../../utilities/formattingUtilities';
import styles from './mvr.module.scss';

/** Redesigned applicant row, rendered as the mock's top "info-bar". */
export const MVRApplicantInfoBar = ({
  applicant,
}: {
  applicant: MVRApplicant;
}) => {
  return (
    <div className={styles.infoBar}>
      <div className={styles.infoField}>
        <div className={styles.fieldLabel}>{Resource.MVR_APPLICANT_NAME}</div>
        <div className={styles.fieldValue}>
          {applicant.name || Resource.NORA_M_DASH}
        </div>
      </div>
      <div className={styles.infoField}>
        <div className={styles.fieldLabel}>
          {Resource.MVR_APPLICANT_BIRTH_DATE}
        </div>
        <div className={styles.fieldValue}>{dateToString(applicant.dob)}</div>
      </div>
      <div className={styles.infoField}>
        <div className={styles.fieldLabel}>
          {Resource.MVR_APPLICANT_ADDRESS}
        </div>
        <div className={styles.fieldValue}>
          {applicant.address || Resource.NORA_M_DASH}
        </div>
      </div>
    </div>
  );
};
